import { Map } from 'immutable';

import {
  FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS,
} from './actions';

export default function progressTestViewLinkReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS:
      return addViewLinkToMap(state, action);
    default:
      return state;
  }
}

function addViewLinkToMap(state, { payload, progressTestId }) {
  let newState = state;
  newState = newState.set(`${progressTestId}`, payload);
  return newState;
}



// WEBPACK FOOTER //
// ./data/ProgressTests/ViewLink/reducer.js